import React from 'react';
import PropTypes from 'prop-types';
import { RadioSwitch } from 'components';
import uiActions from 'state/actions/ui';
import * as gtm from '../search-gtm';
import CONSTANTS from '../constants/constants';
import HamburgerIcon from '@tradera/tradera-ui/icons/hamburger.svg?jsx';
import GridIcon from '@tradera/tradera-ui/icons/grid.svg?jsx';

const handleItemLayoutChange = (dispatch, itemLayout) => {
    gtm.trackFilter('Layout', itemLayout);
    dispatch(uiActions.updateItemLayout(itemLayout));
};

const ItemLayoutSwitch = ({ dispatch, selectedLayout, cssClass, id }) => {
    const options = [
        {
            value: 'layout-grid',
            name: (
                <span>
                    <GridIcon
                        className={`icon icon-sm ${
                            selectedLayout === CONSTANTS.ITEM_LAYOUT.GRID
                                ? 'icon-white'
                                : 'icon-dark'
                        } `}
                    />
                    <span className="d-inline d-md-none ml-2">Galleri</span>
                </span>
            )
        },
        {
            value: 'layout-list',
            name: (
                <span>
                    <HamburgerIcon
                        className={`icon icon-sm ${
                            selectedLayout === CONSTANTS.ITEM_LAYOUT.LIST
                                ? 'icon-white'
                                : 'icon-dark'
                        } `}
                    />
                    <span className="d-inline d-md-none ml-2">Lista</span>
                </span>
            )
        }
    ];

    return (
        <RadioSwitch
            id={id}
            options={options}
            checked={selectedLayout}
            handleOnChange={e => {
                handleItemLayoutChange(dispatch, e);
            }}
            cssClass={cssClass}
        />
    );
};

ItemLayoutSwitch.propTypes = {
    dispatch: PropTypes.func,
    selectedLayout: PropTypes.string,
    cssClass: PropTypes.string,
    id: PropTypes.string.isRequired
};

export default ItemLayoutSwitch;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/search-results/layout/item-layout-switch.jsx